<template>
  <div id="main-content" class="add-student">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.full_name') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.fullname" type=""/>
            <el-col v-if="error_message.fullname" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.fullname" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.display_name') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.display_name" type=""/>
            <el-col v-if="error_message.display_name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.display_name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.furigana') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.furigana" type=""/>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.romaji') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.romaji" type=""/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.gender') }}</span>
            </el-col>
            <select style="" class="input" v-model="admin_data.gender">
              <option value="0">{{ $t('common.female') }}</option>
              <option value="1">{{ $t('common.male') }}</option>
            </select>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.email') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.email" type=""/>
            <el-col v-if="error_message.email" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.email" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.phone') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.phone" type=""/>
            <el-col v-if="error_message.phone" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.phone" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('admin.role') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.position" type=""/>
            <el-col v-if="error_message.position" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.position" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.password') }}</span>
            </el-col>
            <input class="input" v-model="admin_data.password" type="password"/>
            <el-col v-if="error_message.password" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.password" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.password_confirm') }}</span>
            </el-col>
            <input class="input" v-model="password_retype" type="password"/>
            <el-col v-if="error_message.password_retype" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.password_retype" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import { validPhone } from '@/utils'

  export default {
    name: "AddAdmin",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/admin`,
        title: 'admin.add_admin',
        admin_data: {
          fullname: "",
          furigana: "",
          romaji: "",
          display_name: "",
          email: "",
          phone: "",
          gender: 0,
          position: "",
          password: ""
        },
        password_retype: "",
        error_message: {
          fullname: [],
          display_name: [],
          email: [],
          password: [],
          password_retype: [],
          phone: [],
          position: []
        }
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/admin')
          };
          var formData = new FormData()
          for (const [key, value] of Object.entries(this.admin_data)) {
            formData.append(key, value)
          }
          let payload = {
            successCallback,
            data: formData
          }

          this.$store.dispatch('admin/createAdmin', payload);
        }
      },
      validate: function () {
        Object.keys(this.error_message).forEach((key) => {
          this.error_message[key] = []
        })

        if (this.admin_data.fullname.trim() === "") {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.fullname.push('* ' + this.$t('common.name_is_required'))

          return false
        }

        if (this.admin_data.display_name.trim() === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.display_name.push('* ' + this.$t('common.display_name_is_required'))

          return false
        }

        if (this.admin_data.email.trim() === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.email.push('* ' + this.$t('common.email_is_required'))

          return false
        }

        if (!this.validEmail(this.admin_data.email)) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.email.push('* ' + this.$t('common.email_is_invalid'))

          return false
        }

        if (this.admin_data.phone.trim() === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.phone.push('* ' + this.$t('common.phone_is_required'))

          return false
        }

        if (!validPhone(this.admin_data.phone)) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.phone.push('* ' + this.$t('common.phone_is_invalid'))

          return false
        }

        if (this.admin_data.position.trim() === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.position.push('* ' + this.$t('common.role_is_required'))

          return false
        }

        if (this.admin_data.password === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.password.push('* ' + this.$t('common.password_is_required'))

          return false
        }

        if (this.password_retype === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.password_retype.push('* ' + this.$t('common.confirm_password_not_match'))

          return false
        }

        if (this.admin_data.password !== this.password_retype) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message.password_retype.push('* ' + this.$t('common.confirm_password_not_match'))

          return false
        }

        return true
      },
      validEmail: function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    }
  }
</script>

<style lang="scss">

  #drop-time select {
    width: 12%;
    float: left;
    margin-right: 25px;
    margin-left: 2px;
  }
</style>